import api from "../../components/api"
import { ApplicationStatus, RainforestSession, TenantMerchantStatusData } from "./rainforest"

export const getMerchantStatus = async (): Promise<TenantMerchantStatusData> => {
  return (await api.get(`/web/rainforest/merchant-status`)).data
}

export const updateNextDayAch = async (enabled: boolean): Promise<void> => {
  await api.post('/web/rainforest/update-next-day-ach', { enabled })
}

export const startMerchantApplication = async (useSandbox: boolean): Promise<void> => {
  await api.post(`/web/rainforest/start-merchant-application`, { useSandbox })
}

export const setMerchantApplicationStatus = async (status: ApplicationStatus): Promise<void> => {
  await api.post('/web/rainforest/set-merchant-application-status', { status })
}

export const getMerchantOnboardingSession = async (): Promise<RainforestSession> => {
  return (await api.get(`/web/rainforest/session/merchant-onboarding`)).data
}

export const getReportingSession = async (): Promise<RainforestSession> => {
  return (await api.get(`/web/rainforest/session/reporting`)).data
}

export type NewChargebackStatus = 'InquiryActionRequired' | 'DisputeActionRequired'

type NewChargebackData = {
  payinId: string
  status: NewChargebackStatus
}

export const simulateNewChargeback = async (data: NewChargebackData): Promise<void> => {
  await api.post('/web/rainforest/simulate-new-chargeback', data)
}

export type ChargebackStatusChange = 'DisputeActionRequired' | 'ProvisionalWin' | 'Won' | 'Lost'

type ChargebackStatusChangeData = {
  chargebackId: string
  status: ChargebackStatusChange
}

export const simulateChargebackStatusChange = async (data: ChargebackStatusChangeData): Promise<void> => {
  await api.post('/web/rainforest/simulate-chargeback-status-change', data)
}

type NewAchReturnData = {
  payinId: string
}

export const simulateNewAchReturn = async (data: NewAchReturnData): Promise<void> => {
  await api.post('/web/rainforest/simulate-new-ach-return', data)
}

export const simulateNewDeposit = async (): Promise<void> => {
  await api.post('/web/rainforest/simulate-new-deposit', {})
}

type DepositStatusChangeData = {
  depositId: string
}

export const simulateDepositStatusChange = async (data: DepositStatusChangeData): Promise<void> => {
  await api.post('/web/rainforest/simulate-deposit-status-change', data)
}